module.exports = __webpack_public_path__ + "static/media/gridShield.1357a61c.jpg";